import { BEREICH_NAMEN, stufeMindestens, type MeinProjekt, type PapierkorbEintrag } from '@beholder/shared';
import { api } from '../api';
import { Knopf, Laden, Leer, Meldung, datum, datumZeit, useAktion, useDaten } from '../ui';

/** Papierkorb eines Projekts: Gelöschtes aller Bereiche, zurückholen oder (Leitung) endgültig löschen. */
export function Papierkorb({ projekt }: { projekt: MeinProjekt }) {
  const pfad = `/api/projekte/${projekt.id}/papierkorb`;
  const { daten, fehler, neuLaden } = useDaten(() => api.get<{ tage: number; eintraege: PapierkorbEintrag[] }>(pfad), [pfad]);
  const a = useAktion();

  const ziel = (e: PapierkorbEintrag) => `${pfad}/${e.bereich}/${e.id}${e.art === 'Datei' ? '?art=Datei' : ''}`;
  async function zurueck(e: PapierkorbEintrag) {
    if (await a.ausfuehren(() => api.post(ziel(e).replace(/(\?|$)/, '/wiederherstellen$1')))) await neuLaden();
  }
  async function endgueltig(e: PapierkorbEintrag) {
    if (!confirm(`„${e.titel}“ endgültig löschen? Das kann nicht rückgängig gemacht werden.`)) return;
    if (await a.ausfuehren(() => api.delete(ziel(e)))) await neuLaden();
  }

  return (
    <div className="seite">
      <header className="seiten-kopf">
        <h2>Papierkorb</h2>
        {daten && <span className="leise">Gelöschtes bleibt {daten.tage} Tage, danach wird es endgültig entfernt.</span>}
      </header>
      <Meldung>{fehler || a.fehler}</Meldung>
      {!daten && <Laden />}
      {daten?.eintraege.length === 0 && <Leer titel="Der Papierkorb ist leer" />}
      {!!daten?.eintraege.length && (
        <div className="tabelle-rahmen">
          <table className="tabelle">
            <thead>
              <tr>
                <th>Was</th>
                <th>Bereich</th>
                <th>Gelöscht</th>
                <th>Endgültig weg am</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {daten.eintraege.map((e) => {
                const darf = !projekt.archiviert && stufeMindestens(projekt.rechte[e.bereich], 'schreiben');
                return (
                  <tr key={`${e.bereich}-${e.art}-${e.id}`}>
                    <td>
                      <span className="marke">{e.art}</span> <strong>{e.titel}</strong>
                      {e.details && <div className="leise klein">{e.details}</div>}
                    </td>
                    <td>{BEREICH_NAMEN[e.bereich]}</td>
                    <td>
                      {datumZeit(e.geloeschtAm)}
                      {e.geloeschtVonName && <div className="leise klein">von {e.geloeschtVonName}</div>}
                    </td>
                    <td>{datum(e.endgueltigAm)}</td>
                    <td>
                      <div className="reihe">
                        {darf && (
                          <Knopf klein onClick={() => zurueck(e)} disabled={a.laeuft}>
                            Zurückholen
                          </Knopf>
                        )}
                        {projekt.verwalten && !projekt.archiviert && (
                          <Knopf klein art="gefahr" onClick={() => endgueltig(e)} disabled={a.laeuft}>
                            Endgültig löschen
                          </Knopf>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
